export default __webpack_public_path__ + "static/media/number_1.4dfa6a51.svg";